let productLinksArray = document.querySelectorAll('.earlyAccessList__productLink'),
    productPreviewImagesArray = document.querySelectorAll('.earlyAccessList__productImage'),
    popUpProduct = document.querySelector('.earlyAccessPopUp'),
    body = document.querySelector('body'),
    closePopUpButton = document.querySelector('.earlyAccessPopUp__button'),
    popUpImage = document.querySelector('.earlyAccessPopUp__image'),
    popUpContent = document.querySelector('.earlyAccessPopUp__content');

productLinksArray.forEach(link => {
  link.addEventListener('click', event => {
    event.preventDefault();
    openPopUp(event);
  });
});

productPreviewImagesArray.forEach(link => {
  link.addEventListener('click', event => {
    event.preventDefault();
    openPopUp(event);
  });
});

closePopUpButton.addEventListener('click', closePopUp);

function succesSend() {
  let klaviyoForm = document.querySelector('.earlyAccessPopUp__contentFormWrapper .klaviyo-form'),
      popUpFormDescription = document.querySelector('.earlyAccessPopUp__contentForm');

  setTimeout(function checkFormContent() {
    if (klaviyoForm.innerHTML == 0) {
      popUpFormDescription.classList.add('earlyAccessPopUp__contentForm--showMessage');
    } else {
      setTimeout(checkFormContent, 100);
    }
  }, 100);
}

function openPopUp(event) {
  let currentProduct = event.currentTarget.closest('.earlyAccessList__product'),
      currentImage = currentProduct.querySelector('.earlyAccessList__productImage'),
      klaviyoButton = document.querySelector('.earlyAccessPopUp__contentFormWrapper div.needsclick button');

  popUpImage.src = currentImage.src;
  popUpProduct.classList.add('earlyAccessPopUp--active');
  body.classList.add('body--overflow');

  klaviyoButton.addEventListener('click', succesSend);
}

function closePopUp() {
  popUpProduct.classList.remove('earlyAccessPopUp--active');
  body.classList.remove('body--overflow');
}
